// src/env-polyfill.ts
// This polyfill makes process.env available to components imported from invite-system

// Create a global process object if it doesn't exist
if (typeof window.process === 'undefined') {
    window.process = { env: {} } as any;
  }
  
  // Copy all environment variables from import.meta.env to process.env
  Object.entries(import.meta.env).forEach(([key, value]) => {
    // Recreate the NODE_ENV pattern that many libraries expect
    if (key === 'MODE') {
      window.process.env.NODE_ENV = value;
    }
    
    // Copy with both patterns - with and without VITE_ prefix
    window.process.env[key] = value;
    
    // For variables with VITE_ prefix, add a version without the prefix
    if (key.startsWith('VITE_')) {
      const unprefixedKey = key.substring(5); // Remove 'VITE_'
      window.process.env[unprefixedKey] = value;
    }
  });
  
  // Add any specific environment variables that your invite-system needs
  // For example:
  //window.process.env.API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
  window.process.env.API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001';
  window.process.env.ENABLE_AUTH_DEBUG = import.meta.env.VITE_ENABLE_AUTH_DEBUG || 'true';
  
  // Add TypeScript declaration
  declare global {
    interface Window {
      process: {
        env: Record<string, any>;
      };
    }
  }
  
  console.log('Environment variables polyfill loaded:', window.process.env);